<template>
  <div class="card" style="width: 500px; ">
    <div class="card-modal">
      <b-loading
        :is-full-page="true"
        v-model="loading"
        :can-cancel="false"
      ></b-loading>

      <header class="modal-card-head">
        <p class="modal-card-title">Assign Travel Manager</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <b-notification
          type="is-warning is-light"
          :closable="false"
          role="alert"
        >
          The below travel manager will be assigned to
          <b>{{ selectedContacts.length }}</b> contacts
        </b-notification>

        <b-field label="Travel Manager" horizontal>
          <b-taginput
            validation-message="Enter  travel manager's email address"
            ref="taginput"
            v-model="travelArrangers"
            :data="company_contacts"
            autocomplete
            :allow-new="false"
            :open-on-focus="false"
            field="email"
            icon="email"
            maxtags="1"
            :has-counter="false"
            type="is-primary"
            placeholder="Enter travel manager's email address"
            @typing="getFilteredContacts"
          >
            <template v-slot="props">
              <strong>{{ props.option.name }}</strong
              >: {{ props.option.email }}
            </template>
            <template #empty>
              Contact not found
            </template>
            <template #selected="props">
              <b-tag
                v-for="(tag, index) in props.tags"
                :key="index"
                :tabstop="false"
                closable
                size="is-medium"
                @close="$refs.taginput.removeTag(index, $event)"
              >
                {{ tag.name }}
              </b-tag>
            </template>
          </b-taginput>
        </b-field>
        <br />
      </section>

      <footer class="modal-card-foot">
        <b-button label="Close" @click="$emit('close')" />

        <b-button
          :disabled="!isFormValid"
          @click="assignTravelManager()"
          class="button is-primary is-wide"
        >
          Assign Travel Manager
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedContacts: Array,
    policies: Array,
  },
  data() {
    return {
      loading: false,
      selectedTravelPolicy: "",
      company_contacts: this.contacts,
      travelArrangers: [],
    };
  },
  methods: {
    getFilteredContacts(text) {
      this.company_contacts = this.contacts.filter((option) => {
        return (
          option.email.indexOf(text.toString().toLowerCase()) >= 0 ||
          option.name.indexOf(text.toString().toLowerCase()) >= 0
        );
      });
    },

    assignTravelManager() {
      this.loading = true;
      var body = {
        accountId: this.profile.account.id,
        contactId: this.profile.id,
        travelArrangerId: this.travelArrangers[0].id,
        listOfContacts: this.selectedContacts,
      };

      // console.log(this.travelArrangers[0].id);

      this.$app
        .huddleLabsServerCall("profile/assign-travel-manager", body)
        .then((result) => {
          if (result.success) {
            this.success();
            this.loading = false;
            this.$emit("success");
            this.$emit("close");
          } else {
            this.failure();
            this.loading = false;
            this.$emit("close");
          }
        });
    },

    success() {
      this.$buefy.toast.open({
        message: "Travel manager sucessfully assigned.",
        type: "is-success",
      });
    },
    failure() {
      this.$buefy.toast.open({
        duration: 5000,
        message: "There was an error assigning travel manager.",
        position: "is-bottom",
        type: "is-danger",
      });
    },
  },
  mounted() {},
  computed: {
    isFormValid() {
      return this.travelArrangers.length > 0;
    },
    profile() {
      return this.$globals.profile;
    },
    contacts() {
      return this.$store.getters["userManagement/getCompanyContacts"];
    },
  },
};
</script>

<style scoped>
.is-less-bottom {
  margin-bottom: -20px;
}

.section-heading {
  font-size: 25px;
  margin-bottom: 10px;
  display: block;
  padding: 8px 8px;
  border-bottom: 2px solid;
  margin-bottom: 10px;
}
</style>
